import floorFigure from "../../../../../configs/floorFigure";
import { checkForLengthAfterDot } from "../../../../../helpers/checkers";
import { Currencies } from "@orbital/games-frontend-library";
import { keyframes } from "styled-components";

export const liveCashChecker = (value: string, prec: any) => {
  if (checkForLengthAfterDot(value, prec)) {
    return (+floorFigure(value, prec)).toLocaleString(undefined, {
      minimumFractionDigits: prec,
      maximumFractionDigits: prec,
    });
  } else {
    return (+value).toLocaleString(undefined, {
      minimumFractionDigits: prec,
      maximumFractionDigits: prec,
    });
  }
};

export const numberWithCommas = (currency: string, x: string, prec: any) => {
  // console.log({x})
  // const parts = x.toString().split(".");
  // parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  // console.log(parts[0]);
  // Currencies[currency] + parts.join(",").replaceAll(",", ".");
  // console.log({parts}, 'parts');
  // return Currencies[currency] + parts.join(",").replaceAll(",", ".");
  return (
    Currencies[currency] +
    (+x).toLocaleString(undefined, {
      minimumFractionDigits: prec,
      maximumFractionDigits: prec,
    })
  );
};

export const cashAmount = (currency: string, number: number, prec: any) =>
  Currencies[currency] + liveCashChecker(number.toString(), prec);

const movingColumn = keyframes`
  from {
    top: -30px
  }

  to {
    top: 0;
  }
`;
const movingColumnApper = keyframes`
 from {
    top: -30px;
    opacity: 0;
  }

  to {
    top: 0;
    opacity: 1;
    
  }
`;

export const decideAnimation = (i: number | undefined) => {
  if (i !== undefined) {
    return i <= 0 && i > -2 ? movingColumnApper : movingColumn;
  } else {
    return "";
  }
};
